import { TItemType } from '@types';

/**
 * An Item rate card's title: its Item type's name. The live Item types leave out a soft-deleted
 * one, so a rate card whose Item type they don't hold reads "Deleted item type". Blank until they
 * have loaded, rather than say that of every Item type in the meantime.
 */
export const getItemRateCardTitle = (itemType: TItemType | undefined, itemTypesLoaded: boolean) => {
	if (itemType) return itemType.name;
	return itemTypesLoaded ? 'Deleted item type' : '';
}
